import { Box, Button, Dialog, Typography } from '@mui/material';
import { FC } from 'react';

interface IProps {
    open: boolean;
    onClose: () => void;
}
export const DialogFullscreen: FC<IProps> = ({ children, open, onClose }) => {
    return (
        <Dialog fullScreen open={open}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'end',
                    px: 4,
                    py: 2,
                    mb: 5
                }}
            >
                <Button onClick={onClose} sx={{ color: 'black', boxShadow: 'none' }} color="inherit">
                    <Typography variant="h1" className="far fa-times" sx={{ marginRight: 1, fontSize: 30 }}></Typography>
                    Close
                </Button>
            </Box>
            {children}
        </Dialog>
    );
};
